import React, { useEffect, useState } from 'react';
import { getDashboardAsync } from '../../Services/DashboardService';
import Header from '../../Shared/Components/Header/Header';
import CompletionBadge from '../ELearning/Courses/CompletionBadge';
import Card from '../../Shared/Components/Card/Card';
import Table from '../../Shared/Components/Table';
import { Link } from 'react-router-dom';
import { getStatus } from '../../Infrastructure/Utilities/LearnerProgressHelper';
import { Line } from 'rc-progress';
import { getStatusBadge } from '../../Infrastructure/Utilities/LearnerProgressHelper';

const LearnerDashboard = () => {
    const [dashboard, setDashboard] = useState({ courses: [{ course: { badgeImageUrl: '' } }], learningPathways: [] });

    useEffect(() => {
        fetchDashboard();
    }, []);

    const fetchDashboard = async () => {
        let response = await getDashboardAsync("Learner");
        setDashboard(response);
    }

    const hasAssessment = (entry) => {
        if (entry?.hasAssessment !== undefined && entry?.hasAssessment !== null) {
            return !!entry.hasAssessment;
        }

        return !!entry?.course?.hasAssessment;
    };

    const progressValue = (entry) => {
        if (entry.progress !== null && entry.progress !== undefined) {
            return entry.progress;
        }

        return entry.completedDateTime ? 100 : 0;
    };

    const headings = () => {
        return (<>
            <th>Course name</th>
            <th>Status</th>
            <th>Result</th>
            <th>Progress</th>
            <th>score</th>
            <th>Type</th>
            <th></th>
        </>)
    }

    const rowData = () => {
        return (
            <>
                {dashboard.courses.map(
                    (x, i) =>
                        <tr key={i}>
                            <td>{x.course !== null && x.course.title}</td>
                            <td>
                                {getStatus(x.completedDateTime, x.startedDateTime, hasAssessment(x), x.scorePercentage)}
                            </td>
                            <td>{hasAssessment(x) ? getStatusBadge(x.lessonStatus, x.scorePercentage) : <span className="badge badge-secondary">No assessment</span>}</td>
                            <td><Line percent={progressValue(x)} strokeWidth="3" strokeColor="#009fdf" strokeLinecap="round" /></td>
                            <td>{hasAssessment(x) && x.scorePercentage !== null && x.scorePercentage !== undefined ? `${Math.round(x.scorePercentage)}%` : '-'}</td>
                            <td>{hasAssessment(x) ? 'Assessment' : 'Mindfullness'}</td>
                            <td>
                                <Link to={`/engage/${x.course !== null && x.course.id}`} className="btn btn-sm btn-outline-primary action-button float-right mr-3">
                                    View
                                </Link>
                            </td>
                        </tr>
                )
                }
            </>
        )
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <Card title="Courses" >
                        <Table headings={headings} rowData={rowData} />
                    </Card>
                </div>
                <div className="col-12">
                    <Card title="Badges" >
                        {dashboard.courses.map(
                            (c, i) => <CompletionBadge key={i} completed={c.lessonStatus === 4} image={c.course !== null ? c.course.badgeImageUrl : ''} courseId={c.course !== null && c.course.id} />
                        )}
                    </Card>
                </div>
            </div>
        </>
    );
};

export default LearnerDashboard;